<template>
  <div class="toastMask" v-show="visible">
    <div class="my-prize">
      <div class="title">我的中奖纪录</div>
      <div class="content">
        <table class="table-list" v-if="list.length != 0">
          <tbody>
            <tr v-for="(item,index) in list" :key="index">
              <td>{{item.createTime | date}}</td>
              <td>&nbsp;&nbsp;&nbsp;&nbsp;您获得{{item.content}}</td>
            </tr>
          </tbody>
        </table>
        <div class="no-content" v-else>
          <p>哎呀，您没有参加过抽奖哟</p>
        </div>
      </div>
      <div class="close" @click="close"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default: []
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.toastMask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
}
.my-prize {
  min-width: 692px;
  width:auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  .title {
    line-height: 86px;
    height: 86px;
    background: rgb(49, 78, 113);
    left: 86px;
    color: #fff;
    font-size: 30px;
    text-align: center;
    letter-spacing: 4px;
  }
  .content {
    background: #fff;
    padding: 0 77px;
    margin: 50px 0 70px;
    max-height: 282px;
    font-size: 22px;
    color: #575757;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 0px;
    }
    .table-list {
      border-spacing: 0;
      border-collapse: collapse;
      width: 100%;
      td {
        border-bottom: solid 1px rgb(221, 221, 221);
        height: 56px;
        font-size: 22px;
        color: #575757;
        white-space:nowrap;
      }
    }
    .no-content {
      text-align: center;
      padding-top: 10px;
    }
  }
  .close {
    cursor: pointer;
    position: absolute;
    top: -40px;
    right: -40px;
    width: 39px;
    height: 39px;
    background: url("../close.png") center no-repeat;
    background-size: contain;
  }
}
</style>
